import { forwardRef } from 'react'
import './Input.css'

const Input = forwardRef(function Input({
  label,
  hint,
  error,
  className = '',
  textarea,
  id,
  ...props
}, ref) {
  const inputId = id || (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined)
  const inputCls = [
    textarea ? 'form-textarea' : 'form-input',
    error ? 'invalid' : '',
    className,
  ].filter(Boolean).join(' ')

  const Element = textarea ? 'textarea' : 'input'

  return (
    <div className="form-group">
      {label && <label htmlFor={inputId}>{label}</label>}
      <Element
        ref={ref}
        id={inputId}
        className={inputCls}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={error ? `${inputId}-error` : hint ? `${inputId}-hint` : undefined}
        {...props}
      />
      {error && <p className="field-error" id={`${inputId}-error`} role="alert">{error}</p>}
      {!error && hint && <p className="field-hint" id={`${inputId}-hint`}>{hint}</p>}
    </div>
  )
})

export default Input
